import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'model/Auth';
import { useClientDomainParam } from 'helper/ClientDomainParamParser';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import ErrorMessage from 'component/part/ErrorMessage';

const style = {
  layout: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
  },
  logo: {
    display: 'inlineBlock',
    width: '40rem',
    maxWidth: '100%',
    marginTop: '4rem',
  },
  title: {
    margin: '2rem 0',
    fontSize: '2rem',
  },
  inputArea: {
    marginBottom: '1rem',
    ['& input']: {
      width: '32rem !important',
      borderBottom: 'solid 0.1rem #cccccc',
      background: 'none !important',
      '&:internal-autofill-selected': {
        backgroundColor: '#ffffff !important',
      },
    },
    ['& button']: {
      width: 'fit-content',
      margin: '0 auto',
    },
  },
  submit: {
    width: '10rem',
    lineHeight: '3.2rem',
    backgroundColor: '#e9ba32',
    border: 'none',
    borderRadius: '0.5rem',
    boxShadow: '0 0.1rem 0.2rem #00000088',
    color: '#ffffff',
    fontSize: '1.2rem',
    '&:hover': {
      backgroundColor: '#e0b030',
    },
  },
};

const Login = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const clientDomainParam = useClientDomainParam();
  const [accountCode, setAccountCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const executeLogin = async () => {
    const loginResult = await auth.login(accountCode, password);
    if (loginResult) {
      navigate('/');
    } else {
      setError(true);
    }
  };

  return <Layout>
    <div css={style.layout}>
      <img src={`/image/logo/${clientDomainParam.logo}`} css={style.logo} />
      <div css={style.title}>工事台帳管理システム</div>
      <ErrorMessage message={error ? 'ログインに失敗しました。入力内容を確認してください。' : null} />
      <div css={[generalStyle.form, style.inputArea]}>
        <input type='text' onChange={(event) => setAccountCode(event.target.value)} value={accountCode} placeholder='メールアドレスまたはユーザー名*' />
        <input type='password' onChange={(event) => setPassword(event.target.value)} value={password} placeholder='パスワード*' />
        <button type='button' onClick={executeLogin} css={generalStyle.button()}>ログイン</button>
      </div>
    </div>
  </Layout>;
};

export default Login;
